import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { providers } from 'ethers';
import { getAddress } from 'ethers/lib/utils';
import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useConfig, useLocalStorage, useReadonlyNetwork } from '../../../hooks';
import { useReadonlyNetworkStates } from '../readonlyNetworks/context';
import { ConnectorController } from './connectorController';
import { InjectedConnector } from './implementations';
var Provider = providers.Provider;
var getAccount = function getAccount(connector) {
  if (connector === null || connector === void 0 ? void 0 : connector.accounts[0]) {
    return getAddress(connector.accounts[0]);
  }
  return undefined;
};
export var ConnectorContext = createContext({
  connector: undefined,
  //eslint-disable-next-line @typescript-eslint/no-empty-function
  activate: function () {
    var _activate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function activate() {
      return _activate.apply(this, arguments);
    }
    return activate;
  }(),
  //eslint-disable-next-line @typescript-eslint/no-empty-function
  deactivate: function deactivate() {},
  //eslint-disable-next-line @typescript-eslint/no-empty-function
  activateBrowserWallet: function activateBrowserWallet() {},
  //eslint-disable-next-line @typescript-eslint/no-empty-function
  reportError: function reportError() {},
  isLoading: false,
  setError: function setError() {
    throw new Error('Function not implemented.');
  },
  active: false,
  switchNetwork: function switchNetwork() {
    throw new Error('Function not implemented.');
  }
});
export function ConnectorContextProvider(_ref) {
  var children = _ref.children;
  var _a;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    controller = _useState2[0],
    setController = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setLoading = _useState4[1];
  var config = useConfig();
  var connectors = config.connectors,
    autoConnect = config.autoConnect;
  var _useLocalStorage = useLocalStorage('usedapp:autoConnectTag'),
    _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
    autoConnectTag = _useLocalStorage2[0],
    setAutoConnectTag = _useLocalStorage2[1];
  var activate = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(providerOrConnector) {
      var _ref3,
        silently,
        onSuccess,
        controller,
        wrappedProvider,
        _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _ref3 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {
              silently: false
            }, silently = _ref3.silently, onSuccess = _ref3.onSuccess;
            if ('activate' in providerOrConnector) {
              controller = new ConnectorController(providerOrConnector, config);
            } else {
              wrappedProvider = Provider.isProvider(providerOrConnector) ? providerOrConnector : new providers.Web3Provider(providerOrConnector);
              controller = new ConnectorController(new InjectedConnector(wrappedProvider), config);
            }
            setLoading(true);
            setController(controller);
            _context2.prev = 4;
            if (!silently) {
              _context2.next = 10;
              break;
            }
            _context2.next = 8;
            return controller.activate(function (connector) {
              return connector.connectEagerly();
            });
          case 8:
            _context2.next = 12;
            break;
          case 10:
            _context2.next = 12;
            return controller.activate();
          case 12:
            setLoading(false);
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            _context2.next = 19;
            break;
          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](4);
            controller.reportError(_context2.t0);
          case 19:
            _context2.prev = 19;
            setLoading(false);
            return _context2.finish(19);
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[4, 16, 19, 22]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [setController, setLoading]);
  var activateBrowserWallet = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(options) {
      var _options, type;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            // done for backward compatibility.
            // If the options object looks like an event object or is undefined,
            // it's not a valid option and will be ignored
            if (!options || typeof options.preventDefault === 'function') {
              options = {
                type: 'metamask'
              };
            }
            _options = options, type = _options.type;
            if (connectors[type]) {
              _context3.next = 4;
              break;
            }
            throw new Error("Connector ".concat(type, " is not configured"));
          case 4:
            _context3.next = 6;
            return activate(connectors[type], {
              onSuccess: function onSuccess() {
                setAutoConnectTag(type);
              }
            });
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }(), [activate, setAutoConnectTag, connectors]);
  var deactivate = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          setAutoConnectTag(undefined);
          setLoading(true);
          setController(undefined);
          _context4.next = 5;
          return controller === null || controller === void 0 ? void 0 : controller.deactivate();
        case 5:
          setLoading(false);
        case 6:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })), [controller]);
  var reportError = useCallback(function (err) {
    controller === null || controller === void 0 ? void 0 : controller.reportError(err);
  }, [controller]);
  var switchNetwork = useCallback( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(chainId) {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return controller === null || controller === void 0 ? void 0 : controller.switchNetwork(chainId);
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x3) {
      return _ref6.apply(this, arguments);
    };
  }(), [controller]);
  var setErrorDeprecated = useCallback(function () {
    throw new Error('setError is deprecated');
  }, []);
  var ethersActivate = useCallback( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(providerOrConnector) {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (!('getProvider' in providerOrConnector)) {
              _context6.next = 9;
              break;
            }
            console.warn('Using web3-react connectors is deprecated and may lead to unexpected behavior.');
            _context6.next = 4;
            return providerOrConnector.activate();
          case 4:
            _context6.t0 = activate;
            _context6.next = 7;
            return providerOrConnector.getProvider();
          case 7:
            _context6.t1 = _context6.sent;
            return _context6.abrupt("return", (0, _context6.t0)(_context6.t1));
          case 9:
            return _context6.abrupt("return", activate(providerOrConnector));
          case 10:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x4) {
      return _ref7.apply(this, arguments);
    };
  }(), []);
  useEffect(function () {
    if (autoConnect && autoConnectTag && connectors[autoConnectTag]) {
      void activate(connectors[autoConnectTag], {
        silently: true
      });
    }
  }, []);
  useEffect(function () {
    controller === null || controller === void 0 ? void 0 : controller.updateConfig(config);
  }, [controller, config]);
  var readonlyNetwork = useReadonlyNetwork();
  var _useState5 = useState((_a = controller === null || controller === void 0 ? void 0 : controller.errors) !== null && _a !== void 0 ? _a : []),
    _useState6 = _slicedToArray(_useState5, 2),
    errors = _useState6[0],
    setErrors = _useState6[1];
  var _useState7 = useState(getAccount(controller)),
    _useState8 = _slicedToArray(_useState7, 2),
    account = _useState8[0],
    setAccount = _useState8[1];
  var _useState9 = useState(controller === null || controller === void 0 ? void 0 : controller.getProvider()),
    _useState10 = _slicedToArray(_useState9, 2),
    provider = _useState10[0],
    setProvider = _useState10[1];
  var _useState11 = useState(controller === null || controller === void 0 ? void 0 : controller.chainId),
    _useState12 = _slicedToArray(_useState11, 2),
    chainId = _useState12[0],
    setChainId = _useState12[1];
  useEffect(function () {
    if (!(controller === null || controller === void 0 ? void 0 : controller.getProvider())) {
      setAccount(undefined);
      setProvider(readonlyNetwork === null || readonlyNetwork === void 0 ? void 0 : readonlyNetwork.provider);
      setChainId(readonlyNetwork === null || readonlyNetwork === void 0 ? void 0 : readonlyNetwork.chainId);
      setErrors([]);
    } else {
      setChainId(controller.chainId);
      setErrors(controller.errors);
      setProvider(controller.getProvider());
      setAccount(getAccount(controller));
    }
    return controller === null || controller === void 0 ? void 0 : controller.updated.on(function (_ref8) {
      var chainId = _ref8.chainId,
        errors = _ref8.errors,
        accounts = _ref8.accounts;
      if (chainId) {
        setChainId(chainId);
        setProvider(controller.getProvider());
        if (accounts[0]) {
          setAccount(getAddress(accounts[0]));
        } else {
          setAccount(undefined);
        }
      }
      setErrors(_toConsumableArray(errors));
    });
  }, [controller, controller === null || controller === void 0 ? void 0 : controller.getProvider()]);
  var _useConfig = useConfig(),
    networks = _useConfig.networks,
    readOnlyUrls = _useConfig.readOnlyUrls;
  var _useState13 = useState(undefined),
    _useState14 = _slicedToArray(_useState13, 2),
    error = _useState14[0],
    setError = _useState14[1];
  var networkStates = useReadonlyNetworkStates();
  var configuredChainIds = Object.keys(readOnlyUrls || {}).map(function (chainId) {
    return parseInt(chainId, 10);
  });
  var supportedChainIds = networks === null || networks === void 0 ? void 0 : networks.map(function (network) {
    return network.chainId;
  });
  useEffect(function () {
    var isNotConfiguredChainId = chainId && configuredChainIds && configuredChainIds.indexOf(chainId) < 0;
    var isUnsupportedChainId = chainId && supportedChainIds && supportedChainIds.indexOf(chainId) < 0;
    if (isUnsupportedChainId || isNotConfiguredChainId) {
      var chainIdError = new Error("".concat(isUnsupportedChainId ? 'Unsupported' : 'Not configured', " chain id: ").concat(chainId, "."));
      chainIdError.name = 'ChainIdError';
      setError(chainIdError);
      return;
    }
    for (var _i = 0, _Object$values = Object.values(networkStates); _i < _Object$values.length; _i++) {
      var networkState = _Object$values[_i];
      if (networkState.errors.length > 0) {
        setError(networkState.errors[networkState.errors.length - 1]);
        return;
      }
    }
    setError(errors === null || errors === void 0 ? void 0 : errors[errors.length - 1]);
  }, [chainId, errors, networkStates]);
  return _jsx(ConnectorContext.Provider, Object.assign({
    value: {
      connector: controller,
      deactivate: deactivate,
      reportError: reportError,
      activate: ethersActivate,
      activateBrowserWallet: activateBrowserWallet,
      isLoading: isLoading,
      account: account,
      library: provider,
      chainId: (error === null || error === void 0 ? void 0 : error.name) === 'ChainIdError' ? undefined : provider !== undefined ? chainId : readonlyNetwork === null || readonlyNetwork === void 0 ? void 0 : readonlyNetwork.chainId,
      error: error,
      active: !!provider,
      switchNetwork: switchNetwork,
      setError: setErrorDeprecated
    }
  }, {
    children: children
  }));
}
export var useConnector = function useConnector() {
  return useContext(ConnectorContext);
};